import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Institute-admin READ-ONLY view of the WhatsApp channel (v6.7, Gupshup).
 * Drop into Admin settings:  <WhatsAppConfig />
 * Editing (Gupshup source number + API key) is superadmin-only — see
 * SuperadminWhatsAppConfig for the editor, wired into the Superadmin console.
 * Arventiq Labs owns the Gupshup account and assigns each institute's number.
 */
export default function WhatsAppConfig() {
  const [cfg, setCfg] = useState(null);
  const [hasToken, setHasToken] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.whatsappConfig()
      .then((r) => { setCfg(r.config || null); setHasToken(!!r.has_token); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 16, color: "#5b6b8c" }}>Loading WhatsApp settings…</div>;

  const label = { fontSize: 13, color: "#5b6b8c", fontWeight: 600 };
  const configured = !!(cfg && cfg.phone_number_id && hasToken);

  return (
    <div style={{ maxWidth: 520 }}>
      <h3 style={{ margin: "0 0 4px", color: "#0D1A3A" }}>WhatsApp channel</h3>
      <p style={{ fontSize: 13, color: "#5b6b8c", marginTop: 0 }}>
        Staff (admin, authority, technician) can always use WhatsApp for ticket commands. Whether students/
        requesters can also raise tickets over WhatsApp is set below.
      </p>

      <div style={{ marginTop: 12, padding: 14, borderRadius: 10, border: "1px solid #dce1ec", background: "#f6f8fc" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <span style={{
            width: 9, height: 9, borderRadius: "50%",
            background: configured && cfg?.is_active ? "#1BA85C" : "#c7ccd6",
          }} />
          <span style={{ fontWeight: 600, color: "#243b5e" }}>
            {configured ? (cfg.is_active ? "Active" : "Configured, but inactive") : "Not yet configured"}
          </span>
        </div>

        {configured ? (
          <div style={{ fontSize: 13, color: "#5b6b8c" }}>
            <div><span style={label}>Number: </span>{cfg.phone_display || "—"}</div>
            <div style={{ marginTop: 4 }}>
              <span style={label}>Requester ticket-raising: </span>
              {cfg.requester_flow_enabled === false ? "Off (staff-only)" : "On"}
            </div>
          </div>
        ) : (
          <div style={{ fontSize: 13, color: "#5b6b8c" }}>
            No WhatsApp number has been assigned to your institute yet.
          </div>
        )}
      </div>

      <p style={{ fontSize: 12, color: "#5b6b8c", marginTop: 12 }}>
        WhatsApp numbers are set up by Arventiq Labs. Contact us to add or change your institute's number.
      </p>
    </div>
  );
}
